import { IObservable, Subject } from '~/rage/utils';
import { IRadialMenuItem, RadialMenuIcon } from '~/shared';
import {
	IRadialMenuService,
	paginateMenuItems,
} from './radialMenuServiceTypes';

export class RadialMenuServiceStub implements IRadialMenuService {
	private count = 5;

	private rawMenuItems: IRadialMenuItem[] = [
		{
			action: 'owned_vehicle_repair',
			icon: RadialMenuIcon.RepairVehicle,
			text: 'Починка',
			subText: '',
			nestedItems: [
				{
					action: 'owned_vehicle_repair_engine',
					icon: RadialMenuIcon.RepairVehicle,
					text: 'Ремонт двигателя',
					subText: '',
				},
				{
					action: 'owned_vehicle_repair_engine_damage',
					icon: RadialMenuIcon.RepairVehicle,
					text: 'Ремонт кузова',
					subText: '',
				},
				{
					action: 'owned_vehicle_repair_engine_damage1',
					icon: RadialMenuIcon.RepairVehicle,
					text: 'Ремонт ремонта',
					subText: '',
				},
			],
		},
		{
			action: 'owned_vehicle_flip',
			icon: RadialMenuIcon.FlipVehicle,
			text: 'Флип',
			subText: '',
			nestedItems: [
				{
					action: 'owned_vehicle_flip_engine',
					icon: RadialMenuIcon.FlipVehicle,
					text: 'Флип двигателя',
					subText: '',
				},
				{
					action: 'owned_vehicle_flip_engine_money',
					icon: RadialMenuIcon.FlipVehicle,
					text: 'Флип монетки',
					subText: '',
				},
			],
		},
		{
			action: 'owned_vehicle_toggle_lights',
			icon: RadialMenuIcon.ToggleLights,
			text: 'Фары',
			subText: 'Вкл',
		},
		{
			action: 'owned_vehicle_toggle_engine',
			icon: RadialMenuIcon.ToggleEngine,
			text: 'Двигатель',
			subText: '',
		},
		{
			action: 'owned_vehicle_toggle_lock',
			icon: RadialMenuIcon.ToggleLock,
			text: 'Двери',
			subText: '',
			nestedItems: [
				{
					action: 'owned_vehicle_toggle_unlock_door',
					icon: RadialMenuIcon.ToggleLock,
					text: 'Дверь',
					subText: 'Открыть',
				},
				{
					action: 'owned_vehicle_toggle_lock_door',
					icon: RadialMenuIcon.ToggleLock,
					text: 'Дверь',
					subText: 'Закрыть',
				},
				{
					action: 'owned_vehicle_toggle_sell',
					icon: RadialMenuIcon.ToggleLock,
					text: 'Дверь',
					subText: 'Продать',
				},
				{
					action: 'owned_vehicle_toggle_smoke',
					icon: RadialMenuIcon.ToggleLock,
					text: 'Дверь',
					subText: 'Скурить',
					nestedItems: [
						{
							action: 'owned_vehicle_toggle_sell_tobacco',
							icon: RadialMenuIcon.ToggleLock,
							text: 'Кальян',
							subText: 'Забить',
						},
						{
							action: 'owned_vehicle_toggle_sell_smoker',
							icon: RadialMenuIcon.ToggleLock,
							text: 'Подик',
							subText: 'Покурить',
						},
						{
							action: 'owned_vehicle_toggle_sell_smoke',
							icon: RadialMenuIcon.ToggleLock,
							text: 'Тофу',
							subText: 'Купить',
						},
					],
				},
			],
		},
		{
			action: 'test_item_1',
			icon: RadialMenuIcon.Animate,
			text: 'Тест 1',
			subText: 'Анимация',
		},
		{
			action: 'test_item_2',
			icon: RadialMenuIcon.Race,
			text: 'Тест 2',
			subText: 'Гонки',
		},
		{
			action: 'test_item_3',
			icon: RadialMenuIcon.Refuel,
			text: 'Тест 3',
			subText: 'Топливо',
		},
		{
			action: 'test_item_4',
			icon: RadialMenuIcon.Gun,
			text: 'Тест 4',
			subText: 'Оружие',
		},
		{
			action: 'test_item_5',
			icon: RadialMenuIcon.Bonnet,
			text: 'Тест 5',
			subText: 'Капот',
		},
		{
			action: 'test_item_6',
			icon: RadialMenuIcon.FOV,
			text: 'Тест 6',
			subText: 'FOV',
		},
		{
			action: 'test_item_7',
			icon: RadialMenuIcon.GPSRemove,
			text: 'Тест 7',
			subText: 'GPS',
		},
		{
			action: 'test_item_8',
			icon: RadialMenuIcon.InventoryCar,
			text: 'Тест 8',
			subText: 'Инвентарь',
		},
		{
			action: 'test_item_9',
			icon: RadialMenuIcon.EjectOccupant,
			text: 'Тест 9',
			subText: 'Высадить',
		},
		{
			action: 'test_item_10',
			icon: RadialMenuIcon.Exchange,
			text: 'Тест 10',
			subText: 'Обмен',
		},
		{
			action: 'test_item_11',
			icon: RadialMenuIcon.ShowPhotoMode,
			text: 'Тест 11',
			subText: 'Фото',
		},
	];

	private menuItems = new Subject<IRadialMenuItem[]>(
		paginateMenuItems(this.rawMenuItems),
	);
	private bottomCaption = new Subject<string>('Ford Bronco');

	public getItems(): IObservable<IRadialMenuItem[]> {
		return this.menuItems;
	}

	public getBottomCaption(): IObservable<string> {
		return this.bottomCaption;
	}

	public async selectItem(action: string): Promise<void> {
		console.log('radialMenu:selectItem', { action });
	}

	public async exit(): Promise<void> {
		console.log('radialMenu:exit');
	}
}
